import pkg from "../../package.json";
import { Drawing } from "./drawing";
import { serialize } from "./drawing/serialize";

export function download(params: {
  content: string;
  name: string;
  fileExtension: string;
}): void {
  // TODO: Encode blobs to support zipping/downloading multiple files at once.
  //
  // var encoder = new TextEncoder();
  // const buffer = [encoder.encode(params.content)];
  // const blob = new Blob(buffer, {
  //   type: params.mimeType ?? "text/plain",
  // });
  // const file = URL.createObjectURL(blob);
  const file = params.content;

  const element = document.createElement("a");
  element.href = file;
  element.download = `kare.pkg ${params.name} ${new Date()
    .toLocaleString()
    .replace(/[:/]/g, "-")
    .replace(",", "")}.${params.fileExtension}`;
  element.setAttribute("style", "display: none");
  document.body.appendChild(element);
  element.click();
  element.remove();
}

export function exportDrawings(drawings: Drawing[]): void {
  download({
    content: `data:application/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify({
        version: pkg.version,
        drawings: drawings.map((drawing) => serialize(drawing)),
      })
    )}`,
    name: "export",
    fileExtension: "json",
  });
}

export function importDrawings(): Promise<Drawing[]> {
  const fileInput = document.createElement("input") as HTMLInputElement;
  fileInput.type = "file";
  fileInput.accept = ".json";
  fileInput.multiple = false;
  return new Promise((resolve) => {
    fileInput.onchange = () => {
      parseImport(fileInput.files).then((drawings) => {
        resolve(drawings);
        fileInput.remove();
      });
    };
    fileInput.click();
  });
}

function parseImport(files: FileList | null): Promise<Drawing[]> {
  return new Promise((resolve) => {
    const drawings: Drawing[] = [];
    if (files === null) return resolve(drawings);

    const fileReader = new FileReader();
    fileReader.onload = ({ target }) => {
      const file = target?.result?.toString();
      try {
        for (const drawing of JSON.parse(file!).drawings) {
          try {
            drawings.push(new Drawing(drawing));
          } catch {
            // no-op
          }
        }
      } finally {
        resolve(drawings);
      }
    };

    fileReader.readAsText(files[0]);
  });
}
